export const takeFulfilledResults = (settledResults: PromiseSettledResult<unknown>[]) => {
  return settledResults
    .filter((result) => result.status === 'fulfilled')
    .map((result) => result.value);
};

export const takeRejectedReasons = (settledResults: PromiseSettledResult<unknown>[]) => {
  return settledResults
    .filter((result) => result.status === 'rejected')
    .map((result) => result.reason);
};
